<template>
  <div class="notice-list">
    <div class="container py-4">
      <h4 class="mb-4">Announcements</h4>
      <div class="notice-items">
        <div class="notice-item" v-for="item in notices" :key="item.id" @click="viewDetail(item)">
          <div class="notice-content">
            <h5 class="main-title">{{ item.title }}</h5>
            <p class="sub-title">{{ item.subtitle }}</p>
            <div class="notice-time">{{ formatTime(item.create_time) }}</div>
          </div>
          <div class="notice-arrow">
            <i class="bi bi-chevron-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'NoticeList',
  data() {
    return {
      notices: [
        {
          id: 1,
          title: 'Welcome',
          subtitle: "Welcome",
          create_time: '2024-02-06 22:00:00'
        }
      ]
    };
  },
  methods: {
    formatTime(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm');
    },
    viewDetail(item) {
      // 跳转到详情页
      //this.$router.push(`/notice/${item.id}`);
    }
  }
};
</script>

<style scoped lang="scss">
.notice-list {

  .notice-items {
    .notice-item {
      background: #fff;
      border-radius: 12px;
      padding: 16px;
      margin-bottom: 12px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      transition: all 0.3s ease;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
      }

      .notice-content {
        flex: 1;
        padding-right: 16px;

        .main-title {
          font-size: 16px;
          font-weight: 500;
          color: #333;
          margin-bottom: 6px;
        }

        .sub-title {
          font-size: 14px;
          color: #666;
          margin-bottom: 8px;
        }

        .notice-time {
          font-size: 12px;
          color: #999;
        }
      }

      .notice-arrow {
        color: #999;
        font-size: 18px;
      }
    }
  }
}

// 暗色主题适配
.dark {
  .notice-list {
    .notice-item {
      background: #1c2030;

      .notice-content {
        .main-title {
          color: #fff;
        }

        .sub-title {
          color: #999;
        }

        .notice-time {
          color: #666;
        }
      }

      .notice-arrow {
        color: #666;
      }
    }
  }
}
</style>
